import { INaeWidget, WidgetType } from '../v3/utils';
import { Fragment } from 'react';

export const GeneratedLayoutWidgets: INaeWidget[] = [
];
